export default {
    name : 'RewardsHelper',
    computed: {
        globalRewardAmount: () => process.env.VUE_APP_REWARD_AMOUNT,
        globalMinimalPayout: () => process.env.VUE_APP_MIN_PAYOUT_AMOUNT,
    }
}
